import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GridDataResult, DataStateChangeEvent, PageChangeEvent } from '@progress/kendo-angular-grid';
import { State, process, orderBy } from '@progress/kendo-data-query';
import { Subject } from 'rxjs';
import { NotifyType } from '../../../../core/enums/NotifyType';
import { IV6OptionTranslation, IV6OptionValueTranslation } from '../../../../core/models';
import { AppNotifyService } from '../../../../core/services/app-notify.service';
import { ProductService } from '../../../../core/services/product.service';

@Component({
  selector: 'app-manage-translation',
  templateUrl: './manage-translation.component.html',
  styleUrls: ['./manage-translation.component.scss']
})
export class ManageTranslationComponent implements OnInit {
  manageTranslationGridView: GridDataResult;
  manageValueTranslationGridView: GridDataResult;
  translationTemplates: IV6OptionTranslation[] = [];
  valueTranslationTemplates: IV6OptionTranslation[] = [];
  valueTranslationDataLoading: boolean;
  translationDataLoading: boolean;
  public gridItemToRemove: any;
  public removeConfirmationSubject: Subject<boolean> = new Subject<boolean>();

  constructor(private productService: ProductService, private appNotifyService: AppNotifyService,
    private route: ActivatedRoute,
    private router: Router  ) { }

  ngOnInit() {
    this.productService.GetOptionTranslation().subscribe(optionTranslation => 
    {
      this.translationTemplates = optionTranslation;
        this.loadProductGridData();
      });      
  }
  public productGridState: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'id',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };
  protected productGridSortChange(sort): void {
    this.productGridState.sort = sort;
    this.loadProductGridData();
  }

  protected productGridPageChange({ skip, take }: PageChangeEvent): void {
    this.productGridState.skip = skip;
    this.productGridState.take;
    this.loadProductGridData();
  }

  public productGridDataStateChange(state: DataStateChangeEvent): void {
    this.productGridState = state;
    this.loadProductGridData();
  }

  public productValueGridState: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'id',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };

  protected productValueGridSortChange(sort): void {
    this.productValueGridState.sort = sort;
    this.loadProductValueTranslationGridData();
  }

  protected productValueGridPageChange({ skip, take }: PageChangeEvent): void {
    this.productValueGridState.skip = skip;
    this.productValueGridState.take;
    this.loadProductValueTranslationGridData();
  }

  public productValueGridDataStateChange(state: DataStateChangeEvent): void {
    this.productValueGridState = state;
    this.loadProductValueTranslationGridData();
  }
  private loadProductGridData(): void {
    this.translationDataLoading = true;
    this.manageTranslationGridView = process(this.translationTemplates, this.productGridState);
    this.translationDataLoading = false;

  }
  private loadProductValueTranslationGridData() {
    this.productService.GetOptionValueTranslation().subscribe(optionValueTranslation => {
      this.valueTranslationTemplates = optionValueTranslation;
      this.valueTranslationDataLoading = true;
      this.manageValueTranslationGridView = process(this.valueTranslationTemplates, this.productValueGridState);
      this.valueTranslationDataLoading = false;
    }); 
  }
  editTranslation(dataItem: IV6OptionTranslation): void {
    this.productService.editTranslation = dataItem;
    this.router.navigate(['./edit-translation'], { relativeTo: this.route }); 
  }
  editValueTranslation(dataItem: IV6OptionValueTranslation): void {
    this.productService.editValueTranslation = dataItem;
    this.router.navigate(['./edit-value-translation'], { relativeTo: this.route }); 
  }
  onTabSelect($event) {
    if ($event.index == 1) {
      this.loadProductValueTranslationGridData();
    }
  }

  //#region delete item
  public removeType: string;
  public removeConfirmation(dataItem, type): Subject<boolean> {
    this.gridItemToRemove = dataItem; // show delete item confirmation box
    this.removeType = type;
    return this.removeConfirmationSubject;
  }

  protected confirmRemove(shouldRemove: boolean): void {
    if (shouldRemove) {
      this.removeConfirmationSubject.next(shouldRemove);
      this.itemRemoveHandler();
    }
    else {
      this.removeConfirmationSubject.next(shouldRemove);
      this.gridItemToRemove = null;
      this.removeType = "";
    }
  }
  protected itemRemoveHandler() {
    const itemId = this.gridItemToRemove.id;
    let body = {
      id: itemId
    }
    if (this.removeType == "OptionTrans") {
      this.productService.deleteOptionTranslator(body).subscribe(() => {

        this.gridItemToRemove = null;
        this.appNotifyService.notify(NotifyType.SUCCESS, "Selected item has been removed.");

        if (this.translationTemplates) {
          //This is a Local Remove
          const index = (this.translationTemplates).findIndex(r => r.id === itemId);
          (this.translationTemplates).splice(index, 1);
          this.loadProductGridData();

        }

      }, error => {
        this.appNotifyService.notify(NotifyType.ERROR, 'An Error Occured');
      });
    }
    else if (this.removeType == "OptionValueTrans") {
      this.productService.deleteOptionValueTranslator(body).subscribe(() => {

        this.gridItemToRemove = null;
        this.appNotifyService.notify(NotifyType.SUCCESS, "Selected item has been removed.");

        if (this.valueTranslationTemplates) {
          //This is a Local Remove
          const index = (this.valueTranslationTemplates).findIndex(r => r.id === itemId);
          (this.valueTranslationTemplates).splice(index, 1);
          this.loadProductValueTranslationGridData();

        }

      }, error => {
        this.appNotifyService.notify(NotifyType.ERROR, 'An Error Occured');
      });
    }
    this.removeType = "";
  }
  //#endregion
}
